import { useAuth } from 'react-oidc-context';
import { BaseModalProps, Button, ModalContentWrapper } from 'ui';

interface SuccessTaskCompletionModalProps extends BaseModalProps {
  taskName: string;
  onClick?: () => void;
}

const SuccessTaskCompletionModal = ({
  taskName,
  onClick,
  open,
  onClose,
}: SuccessTaskCompletionModalProps) => {
  const auth = useAuth();
  return (
    <ModalContentWrapper
      title={`Task "${taskName}" completed`}
      open={open}
      onClose={onClose}
      showClose={false}
    >
      <div className="space-y-4">
        <p className="text-2xl text-gray-600 text-center">
          All done! Your responses have been submitted successfully. Thanks for your time!
        </p>
        <Button
          onClick={() => {
            onClick && onClick();
            auth.signinRedirect();
          }}
        >
          Go to dashboard
        </Button>
      </div>
    </ModalContentWrapper>
  );
};

export default SuccessTaskCompletionModal;
